import styled from 'styled-components';

export const PrintSection = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  opacity: 0;
  font-family: var(--bllink-font-primary);

  .logos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding: 20px 15px;

    .empty {
      display: none;
    }

    img {
      width: 100%;
    }

    .logo-top {
      width: 300px;
    }

    .partner {
      width: 100px;
    }
  }

  .table-container {
    padding: 30px 15px;
    background-color: #fff;
  }

  .note {
    margin-top: 35px;
    text-align: start;
    font-size: 20px;
  }
`;
